import './Tabs.sass'
import Tabs from './Tabs'

export default Tabs
